import React from "react";

const PostButton = ({ onClick, text, type = "button", disabled = false, className = "" }) => {
  return (
    <button type={type} onClick={onClick} disabled={disabled} className={`
      w-full rounded-xl bg-[#6469ff] px-6 py-3 text-sm font-semibold text-white transition-all duration-200 hover:bg-[#555bea] active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-[#6469ff] ${className}
      `}
    >
      {text || "Create"}
    </button>
  );
};

export default PostButton;